import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25" }
const _hoisted_3 = { class: "fs-18 fw-semibold text-black mb-5 mb-md-8" }
const _hoisted_4 = { class: "d-flex gap-3 justify-content-between align-items-start" }
const _hoisted_5 = { class: "overall-range" }
const _hoisted_6 = { class: "fs-12 text-body-tertiary text-uppercase" }
const _hoisted_7 = { class: "px-1" }
const _hoisted_8 = { class: "fs-12 text-body-tertiary text-uppercase" }
const _hoisted_9 = { class: "d-inline-flex gap-2" }
const _hoisted_10 = {
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = ["disabled", "value"]
const _hoisted_13 = {
  key: 0,
  value: "day"
}
const _hoisted_14 = { value: "week" }
const _hoisted_15 = { value: "month" }
const _hoisted_16 = {
  key: 1,
  class: "chart mb-25"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white"
}
const _hoisted_19 = { class: "card-body p-15 p-sm-20 p-sm-25 pt-lg-30 pb-lg-30 ps-lg-25 pe-lg-25" }
const _hoisted_20 = { class: "table-responsive" }
const _hoisted_21 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-12 pt-0"
}, null, -1 /* HOISTED */)
const _hoisted_23 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_24 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_25 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_26 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_27 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_28 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_29 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end"
}
const _hoisted_30 = {
  class: "shadow-none lh-1 fw-medium text-primary border-bottom-0 border-top-0 bg-light-subtle text-uppercase",
  colspan: "8"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-primary border-bottom-0" }, null, -1 /* HOISTED */)
const _hoisted_32 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_33 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_34 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_35 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_36 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_37 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_38 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_39 = {
  key: 0,
  class: "border-bottom border-light-subtle"
}
const _hoisted_40 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_41 = { class: "opacity-25 text-body-tertiary fs-12 text-uppercase" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_43 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end fs-12 text-uppercase opacity-25 text-body-tertiary" }
const _hoisted_44 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_45 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_46 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_47 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_48 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_49 = { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }
const _hoisted_50 = { class: "opacity-75 border-0 border-5 border-light border-top" }
const _hoisted_51 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "shadow-none lh-1 fw-normal text-body-tertiary text-end" }, null, -1 /* HOISTED */)
const _hoisted_53 = { class: "shadow-none lh-1 fw-bold text-end" }
const _hoisted_54 = { class: "shadow-none lh-1 fw-bold text-body-tertiary text-end" }
const _hoisted_55 = { class: "shadow-none lh-1 fw-bold text-body-tertiary text-end" }
const _hoisted_56 = { class: "shadow-none lh-1 fw-bold text-body-tertiary text-end" }
const _hoisted_57 = { class: "shadow-none lh-1 fw-bold text-body-tertiary text-end" }
const _hoisted_58 = { class: "shadow-none lh-1 fw-bold text-body-tertiary text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FKBreadCrumbItem = _resolveComponent("FKBreadCrumbItem")!
  const _component_FKBreadCrumb = _resolveComponent("FKBreadCrumb")!
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FKBreadCrumb, {
      page: _ctx.$t('page.therapy_trend')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.patients'),
          to: "/patients"
        }, null, 8 /* PROPS */, ["page"]),
        _createVNode(_component_FKBreadCrumbItem, {
          page: _ctx.$t('page.patient'),
          to: `/patient/${_ctx.patient_id}`
        }, null, 8 /* PROPS */, ["page", "to"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["page"]),
    _createCommentVNode(" CHART "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$t('feature.therapy.overall_adherence')), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("feature.therapy.$range.from")) + ":", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.range_from), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("feature.therapy.$range.to")) + ":", 1 /* TEXT */),
            _createElementVNode("span", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-light border-0 fw-light px-1 py-0 m-0", _ctx.range_to_selected == _ctx.range_to ? 'bg-dark-subtle' : '']),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.update_range(_ctx.range_to)))
                }, _toDisplayString(_ctx.range_to), 3 /* TEXT, CLASS */),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-outline-light border-0 fw-light px-1 py-0 m-0", _ctx.range_to_selected == _ctx.range_today ? 'bg-dark-subtle' : '']),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.update_range(_ctx.range_today)))
                }, "Today", 2 /* CLASS */)
              ]),
              _createCommentVNode(" <span class=\"cursor-pointer\" @click=\"update_range(range_to)\">{{ range_to }}</span><span class=\"cursor-pointer\" @click=\"update_range(range_today)\">Today</span> ")
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("select", {
              class: "form-select shadow-none text-black p-15 pe-50 bg-body-tertiary fs-14 border-0",
              disabled: _ctx.loading,
              required: "",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadTrends && _ctx.loadTrends(...args))),
              value: _ctx.range_type
            }, [
              (_ctx.single_therapy)
                ? (_openBlock(), _createElementBlock("option", _hoisted_13, _toDisplayString(_ctx.$t("feature.therapy.$trend_range.$frequency.day")), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("feature.therapy.$trend_range.$frequency.week")), 1 /* TEXT */),
              _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("feature.therapy.$trend_range.$frequency.month")), 1 /* TEXT */)
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-25"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_ctx.empty_data)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("feature.therapy.no_data")), 1 /* TEXT */))
                : (_openBlock(), _createBlock(_component_apexchart, {
                    key: 1,
                    height: "350",
                    id: "adherence_chart",
                    options: _ctx.lineOptions,
                    series: _ctx.adherencesLineSeries
                  }, null, 8 /* PROPS */, ["options", "series"]))
            ])),
        _createCommentVNode(" <div class=\"chart\">\n                <apexchart height=\"350\" id=\"counters_chart\" :options=\"lineOptions\" :series=\"countLineSeries\">\n                </apexchart>\n            </div> ")
      ])
    ]),
    (!_ctx.loading && !_ctx.empty_data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("table", _hoisted_21, [
                _createCommentVNode(" HEADER "),
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_22,
                    _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('feature.therapy.drug')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('feature.therapy.adherence')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_25, _toDisplayString(_ctx.$t('feature.therapy.intake.expected')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_26, _toDisplayString(_ctx.$t('feature.therapy.intake.taken')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$t('feature.therapy.intake.taken_in_time')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_28, _toDisplayString(_ctx.$t('feature.therapy.intake.taken_not_in_time')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_29, _toDisplayString(_ctx.$t('feature.therapy.intake.not_taken')), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.range_groups, (ranges, range_index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: range_index }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_30, [
                          (_ctx.ranges_start(ranges) !== undefined && _ctx.ranges_end(ranges) !== undefined)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.display_range(_ctx.range_type, _ctx.ranges_start(ranges)!, _ctx.ranges_end(ranges)!)), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t(`feature.therapy.$trend_range.${_ctx.range_type}`)) + " " + _toDisplayString(range_index), 1 /* TEXT */)
                              ], 64 /* STABLE_FRAGMENT */)),
                          _createCommentVNode(" <template v-if=\"range_type === 'day'\">\n                                        <template v-if=\"ranges_start(ranges) !== undefined\">\n                                            {{ DateFormat.DAY_FULL_MONTH(ranges_start(ranges)!) }}\n                                        </template>\n                                        <template v-else>\n                                            {{ $t(`feature.therapy.$trend_range.${range_type}`) }} {{\n                                                range_index }}\n                                        </template>\n                                    </template>\n                                    <template v-if=\"range_type === 'week'\">\n                                        {{ $t(`feature.therapy.$trend_range.${range_type}`) }} {{\n                                            range_index }}\n                                        <template\n                                            v-if=\"ranges_start(ranges) !== undefined && ranges_end(ranges) !== undefined\">\n                                            <span class=\"small ms-3 d-inline-flex gap-1\">\n                                                {{ DateFormat.DAY_ABBR_MONTH(ranges_start(ranges)!) }}\n                                                <i class=\"ph ph-arrow-right\"></i>\n                                                {{ DateFormat.DAY_ABBR_MONTH(ranges_end(ranges)!) }}\n                                            </span>\n                                        </template>\n                                    </template>\n                                    <template v-if=\"range_type === 'month'\">\n                                        <template v-if=\"ranges_start(ranges)! !== undefined\">\n                                            {{ DateFormat.FULL_MONTH(ranges_start(ranges)!) }}\n                                        </template>\n                                        <template v-else>\n                                            {{ $t(`feature.therapy.$trend_range.${range_type}`) }} {{\n                                                range_index }}\n                                        </template>\n                                    </template> ")
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ranges, (trend, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass([{ 'border-bottom': index !== 0 && index === ranges.length - 1 }])
                        }, [
                          _hoisted_31,
                          _createElementVNode("td", _hoisted_32, _toDisplayString(trend.drug), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_33, _toDisplayString(trend.adherence) + "% ", 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_34, _toDisplayString(_ctx.expected(trend)), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_35, _toDisplayString(trend.taken), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_36, _toDisplayString(trend.in_time), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_37, _toDisplayString(trend.not_in_time), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_38, _toDisplayString(trend.not_taken), 1 /* TEXT */)
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (ranges.length !== 1)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("div", _hoisted_41, [
                                _createTextVNode(_toDisplayString(_ctx.$t(`feature.therapy.$trend_range.${_ctx.range_type}`).toUpperCase()) + " " + _toDisplayString(range_index), 1 /* TEXT */),
                                _hoisted_42
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.$t('feature.therapy.intake.subtotal')), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.total_adherence(ranges)) + "% ", 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_45, _toDisplayString(_ctx.total_intakes_expected(ranges)), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.total_intakes_taken(ranges)), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.total_intakes_taken_in_time(ranges)), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.total_intakes_taken_not_time(ranges)), 1 /* TEXT */),
                            _createElementVNode("td", _hoisted_49, _toDisplayString(_ctx.total_intakes_not_taken(ranges)), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("tr", _hoisted_50, [
                    _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.$t('feature.therapy.intake.total')), 1 /* TEXT */),
                    _hoisted_52,
                    _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.total_adherence(_ctx.therapy_trends)) + "% ", 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.total_intakes_expected(_ctx.therapy_trends)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.total_intakes_taken(_ctx.therapy_trends)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.total_intakes_taken_in_time(_ctx.therapy_trends)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.total_intakes_taken_not_time(_ctx.therapy_trends)), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.total_intakes_not_taken(_ctx.therapy_trends)), 1 /* TEXT */)
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}